module.exports = __webpack_public_path__ + "media/icons/naped-przod-white@2x-3d062ef4.png";